import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ breakpoints } : Theme) => createStyles({
  cardField: {

  },
  buttonPanel: {
    marginTop: 20,
  },
}));

export default useStyles;
